import { render, staticRenderFns } from "./DocumentLinkList.vue?vue&type=template&id=6d65bff0&scoped=true"
import script from "./DocumentLinkList.vue?vue&type=script&lang=js"
export * from "./DocumentLinkList.vue?vue&type=script&lang=js"
import style0 from "./DocumentLinkList.vue?vue&type=style&index=0&id=6d65bff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d65bff0",
  null
  
)

export default component.exports